// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251404/js/" + chunkId + "." + {"44":"7b7aa218","225":"59aca629","481":"06ba54e7","486":"2c59c5b4","770":"86956d41"}[chunkId] + ".0.43826538214955724.chunk.js";
};